<app-form (onsubmit)="submit()">
  <div class="space-y-4">
    <div class="flex flex-col gap-4">
      <div class="flex gap-4 not-sm:flex-wrap">
        <app-text #manualLookup [inputmode]="inputmode()" label="Search" [required]="true" [(value)]="value" class="w-full"></app-text>

        <app-select [(selected)]="type" [required]="true" [options]="options" class="w-full sm:max-w-1/4"/>
      </div>
    </div>

    <app-button variant="primary" type="submit">
      View Results
    </app-button>
  </div>
</app-form>
